import React from "react";
import MainTemplate from "../../../components/MainTemplate/MainTemplate";
import CardBackground from "../../../components/MainTemplate/CardBackground";
import AssetOutwardHistoryChild from "./AssetOutwardHistoryChild";

const AssetOutwardHistory = () => {
  return (
    <MainTemplate>
      <CardBackground>
        <AssetOutwardHistoryChild />
      </CardBackground>
    </MainTemplate>
  );
};

export default AssetOutwardHistory;
